
  import { mapState } from 'vuex'
  import AreYouSurePopup from '@/components/da-signer/AreYouSurePopup.vue'
  import APICredsPopup from '@/components/settings/APICredsPopup.vue'

  export default {
    name: `APIClientManagement`,
    components: {
      AreYouSurePopup,
      APICredsPopup
    },
    data() {
      return {
        clientSecret: ``,
        loading: {
          create: false,
          delete: false,
          regenerate: false
        },
        popups: {
          deleteAPIClientConfirmation: false,
          createAPIClientConfirmation: false,
          createAPIClientCredentials: false,
          regenerateAPIClientConfirmation: false
        }
      }
    },
    computed: {
      ...mapState({
        apiClient: (state) => state.settings.me.company_information.api_client
      })
    },
    methods: {
      showDeleteAPIClientConfirmation() {
        this.popups.deleteAPIClientConfirmation = true
      },
      closeDeleteAPIClientPopup() {
        this.popups.deleteAPIClientConfirmation = false
      },
      showCreateAPIClientConfirmation() {
        this.popups.createAPIClientConfirmation = true
      },
      closeCreateAPIClientConfirmation() {
        this.popups.createAPIClientConfirmation = false
      },
      showCreateAPIClientCredentials() {
        this.popups.createAPIClientCredentials = true
      },
      closeCreateAPIClientCredentials() {
        this.popups.createAPIClientCredentials = false
      },
      showRegenerateAPIClientConfirmation() {
        this.popups.regenerateAPIClientConfirmation = true
      },
      closeRegenerateAPIClientPopup() {
        this.popups.regenerateAPIClientConfirmation = false
      },
      showMessage(message) {
        this.$flashMessage.info({
          title: this.$t(`messages.message_sent`),
          message
        })
      },
      async setValue(value) {
        await this.$store.commit(`settings/SET_VALUE`, {
          namespace: `company_information`,
          key: `api_client`,
          value
        })
      },
      deleteAPIClient() {
        this.loading.delete = true
        this.$api.settings
          .deleteAPIClient()
          .then(async () => {
            this.showMessage(this.$t(`components.settings.api_client_management.client_deleted`))
            await this.setValue({
              client_id: null,
              client_name: null,
              client_scope: null
            })
          })
          .finally(() => {
            this.loading.delete = false
          })
      },
      createClient() {
        this.closeCreateAPIClientConfirmation()
        this.loading.create = true
        this.loading.regenerate = true
        this.$api.settings
          .createAPIClient()
          .then(async (response) => {
            this.showMessage(this.$t(`components.settings.api_client_management.client_created`))
            this.clientSecret = response._data.client_secret
            await this.setValue({
              client_id: response._data.client_id,
              client_name: response._data.client_name,
              client_scope: response._data.client_scope
            })
            this.showCreateAPIClientCredentials()
          })
          .finally(() => {
            this.loading.create = false
            this.loading.regenerate = false
          })
      }
    }
  }
